export const ME_CONTROL_CONTAINER_ID = 'me-control-container';
export const ME_CONTROL_FALLBACK_ID = 'me-control-fallback';
export const ME_CONTROL_DOM_ID = 'mectrl_main_trigger';
